import { InputCheck } from "controls";
import React from "react";

const InputAccessLayout = ({
  handleInpChg,
  title,
  name,
  values,
  AccessComponet,
  className = "italic font-semibold",
}) => {
  return (
    <div className="shadow-sm rounded-[20px] border !border-slate-200 uppercase pl-[11px]">
      <InputCheck
        label={
          <span className={`text-gray-500 text-[18px] ${className}`}>
            {title}
          </span>
        }
        checked={values[name] || false}
        name={name}
        onClick={handleInpChg}
      />

      {AccessComponet && AccessComponet}
    </div>
  );
};

export default InputAccessLayout;
